// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__I69qP","title":"ClientInsurance_title__2oEtC","itemText":"ClientInsurance_itemText__UQ26R"};